import {Component, Input, OnChanges, ViewChild} from '@angular/core';
import {PrintOptions} from '../../common/components/buttons/print-options.helper';
import {Level, ToastService} from '../../services/toast.service';
import {StudentService} from '../../services/student.service';
import {DistrictService} from '../../services/district.service';
import {DistrictIRIPConfig} from '../../common/dtos/DistrictIRIPConfig';
import {StudentIripComponent} from './student-irip.component';
import {IRIPDto} from '@sidr/dto-types';

@Component({
  selector: 'app-student-irip-list',
  templateUrl: './student-irip-list.component.html',
  styleUrls: ['./student-irip-list.component.scss']
})
export class StudentIripListComponent implements OnChanges {
  irips: IRIPDto[];
  @Input() districtId: string;
  @Input() studentId: string;
  @Input() printOptions: PrintOptions;
  assessments: any;

  @ViewChild('openIrip') openIrip: StudentIripComponent;

  iripConfig: DistrictIRIPConfig;

  notificationTitle = 'IRIP';
  selectedIRIP: IRIPDto | null = null;

  isDirty: boolean;
  isTouched: boolean;

  constructor(
    private studentService: StudentService,
    private districtService: DistrictService,
    private toastService: ToastService) {
    this.assessments = {};
  }

  ngOnChanges() {
    if (this.districtId && this.studentId) {
      this.getData();
    }
  }

  isValidObjectId(str: string) {
    const objectIdPattern = /^[0-9a-fA-F]{24}$/;
    return objectIdPattern.test(str);
  }

  getData() {
    this.districtService.getDistrictIRIPConfig(this.districtId).subscribe(r => {
      this.iripConfig = r;
      this.assessments = this.iripConfig.assessments;
    });
    this.studentService.getIRIPs(this.districtId, this.studentId).subscribe(r => {
      this.irips = r || [];

      const objectIdKeys = new Set<string>();
      this.irips.forEach(irip => {
        for (const key of Object.keys(irip.assessment_result_obj)) {
          if (this.isValidObjectId(key)) {
            objectIdKeys.add(key);
          } else {
            this.assessments[key] = key.toUpperCase();
          }
        }
      });

      if (objectIdKeys.size > 0) {
        this.districtService.getAssessments(this.districtId, 'ELA', true, Array.from(objectIdKeys))
        .subscribe(response => {
          response.forEach(assessment => {
            this.assessments[assessment.id] = assessment.name.toUpperCase();
          });
        });
      }
    }, err => {
      this.toastService.AddNotification(Level.ERROR, this.notificationTitle, err.error);
    });
  }

  exists(obj: any, key: string): boolean {
    if (!key) {
      return false;
    }
    const lower = key.toLowerCase().trim();
    const keys = Object.keys(obj).map(k => k.toLowerCase().trim());

    return keys.includes(lower);
  }

  makeAssessmentObj(): {
    [key: string]: {
      [key: string]: string;
    };
  } {
    const assessmentIds: string[] = Object.keys(this.iripConfig.assessments) || [];
    const obj: {
      [key: string]: {
        [key: string]: string;
      };
    } = {};
    assessmentIds.forEach(id => {
      obj[id] = {} as {
        [key: string]: string;
      }
    });
    return obj;
  }

  open(index: number | null, irip: IRIPDto | null) {
    const assessmentIds: string[] = Object.keys(this.iripConfig.assessments) || [];
    const tIrip = irip ? {...irip} : {
      areas_of_growth: [],
      assessment_result: '',
      assessment_result_obj: this.makeAssessmentObj(),
      grade: '',
      guardian: '',
      guardian_collaboration_date: '',
      guardian_notification_date: '',
      home_plan_provided: '',
      interventions: [],
      learning_goals: '',
      notes_from_guardian_collaboration: '',
      other_factors: '',
      result_of_intervention: '',
      school_year: '',
      strengths: '',
      teacher_id: '',
      team_members: [],
      date: ''
    } as IRIPDto;

    const keysToMake: string[] = [];
    tIrip.assessment_result_obj = tIrip.assessment_result_obj || {}; // Default object

    for (let i = 0; i < assessmentIds.length; i++) {
      const key = assessmentIds[i];
      const value = this.iripConfig.assessments[key];


      if (this.exists(tIrip.assessment_result_obj, key)) {
        continue;
      }
      if (this.exists(tIrip.assessment_result_obj, value)) {
        continue;
      }
      if (!this.isValidObjectId(key)) {
        continue;
      }
      console.log(key, value);
      keysToMake.push(key);
    }
    for (let i = 0; i < keysToMake.length; i++) {
      const key = keysToMake[i];
      tIrip.assessment_result_obj[key] = {};
    }
    this.selectedIRIP = tIrip;
  }

  print(id: string) {
    this.studentService.getIRIPPrint(this.districtId, this.studentId, id).subscribe(r => {
      const url = window.URL.createObjectURL(r);
      window.open(url);
    });
  }

  close(canceled: boolean) {
    if (!canceled) {
      this.getData();
    }

    this.selectedIRIP = null;
  }

  delete(id: string) {
    this.studentService.deleteIRIP(this.districtId, this.studentId, id).subscribe(r => {
      this.getData();
    });
  }

}
